var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from "react";
// Material UI
import Drawer from "@mui/material/Drawer";
import { List, ListItemButton, ListItemIcon, Box, Stack, } from "@mui/material";
import Favorite from "@mui/icons-material/Favorite";
import ManageAccountsOutlinedIcon from "@mui/icons-material/ManageAccountsOutlined";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
// Say Lib
import { Text, Logo, SayLogo, SaySLogo } from "../../Atoms";
import ProfileMenu from "../ProfileMenu";
import { COLORS } from "../../../constants";
var MiniDrawer = function (_a) {
    var toggleExpand = _a.toggleExpand, items = _a.items, listElement = _a.listElement, _b = _a.sx, sx = _b === void 0 ? { position: "sticky", top: "0" } : _b, onClickItem = _a.onClickItem, _c = _a.open, open = _c === void 0 ? false : _c, optionalPaperProps = _a.optionalPaperProps, _d = _a.expandedWidth, expandedWidth = _d === void 0 ? "200px" : _d, _e = _a.collapsedWidth, collapsedWidth = _e === void 0 ? "96px" : _e, _f = _a.textColors, textColors = _f === void 0 ? {
        active: { shade: "say" },
        inactive: {},
    } : _f, _g = _a.listActiveBg, listActiveBg = _g === void 0 ? true : _g, _h = _a.iconColors, iconColors = _h === void 0 ? {
        active: COLORS.SAY_COBALT,
        inactive: COLORS.BLACK,
    } : _h, footerItems = _a.footerItems, profileProps = _a.profileProps, _j = _a.showSayLogo, showSayLogo = _j === void 0 ? false : _j, onLogoClick = _a.onLogoClick, rest = __rest(_a, ["toggleExpand", "items", "listElement", "sx", "onClickItem", "open", "optionalPaperProps", "expandedWidth", "collapsedWidth", "textColors", "listActiveBg", "iconColors", "footerItems", "profileProps", "showSayLogo", "onLogoClick"]);
    var getStyles = function () {
        var width = open ? expandedWidth : collapsedWidth;
        var paperProps = {
            width: width,
            transition: "width ease-in-out 300ms",
            whiteSpace: "nowrap",
            overflowY: "unset",
            boxSizing: "border-box",
            display: "flex",
            backgroundColor: "#F0F0F0",
            position: "static",
            borderRight: "1px solid ".concat(COLORS.P_OUTLINE),
        };
        return __assign({ ".MuiPaper-root": __assign(__assign({}, paperProps), optionalPaperProps) }, (sx ? sx : {}));
    };
    /**
     * Render list of items, or ReactNode passed in or nothing
     */
    var getList = function (listItems, flex) {
        if (listItems) {
            return (_jsx(List, __assign({ sx: { flex: flex, pt: 6 } }, { children: listItems.map(function (itm) {
                    var icon = itm.defaultIcon ? _jsx(Favorite, {}) : itm.icon;
                    var activeIcon = itm.activeIcon || icon;
                    return (_jsxs(ListItemButton, __assign({ sx: {
                            width: open ? 176 : 72,
                            transition: "width ease-in-out 300ms",
                            borderRadius: 200,
                            mx: 3,
                            py: 3,
                            px: 6,
                            whiteSpace: "nowrap",
                            overflowX: "hidden",
                            "&:hover": {
                                bgcolor: COLORS.SECONDARY_HOVER,
                                "&:active": {
                                    bgcolor: "transparent",
                                },
                            },
                            "&.MuiListItemButton-root": {
                                bgcolor: itm.active && listActiveBg
                                    ? COLORS.OVERLAY_PRESSED
                                    : undefined,
                                "& > .MuiTouchRipple-root": {
                                    color: COLORS.OVERLAY_PRESSED,
                                    ".MuiTouchRipple-ripple": {
                                        opacity: "1 !important",
                                    },
                                },
                            },
                            ".MuiListItemIcon-root": {
                                minWidth: "34px",
                                zIndex: 1,
                            },
                        }, "data-testid": "listitem-drawer-row", onClick: onClickItem ? function () { return onClickItem(itm.value); } : undefined }, { children: [icon ? (_jsx(ListItemIcon, __assign({ sx: {
                                    ".MuiSvgIcon-root": {
                                        color: itm.active
                                            ? iconColors.active
                                            : iconColors.inactive,
                                        width: "24px",
                                        height: "24px",
                                    },
                                } }, { children: itm.active ? activeIcon : icon }))) : null, open && (_jsx(Text, __assign({ variant: itm.active ? "subtitle2" : "body2", sx: { ml: icon ? "0" : "34px", zIndex: 1 } }, (itm.active ? textColors.active : textColors.inactive), { children: itm.text }))), itm.node ? itm.node : null] }), itm.value));
                }) })));
        }
        return null;
    };
    var topList = useMemo(function () { return getList(items, 1); }, [items, open]);
    var bottomList = useMemo(function () { return getList(footerItems, 0); }, [footerItems, open]);
    var _k = __read(React.useState(null), 2), anchorEl = _k[0], setAnchorEl = _k[1];
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (_jsxs(Drawer, __assign({ variant: "permanent" }, rest, { open: open, "data-testid": "wrapper-saylib-drawer", sx: __assign(__assign({}, getStyles()), { "&:hover .MuiDrawer-chevron": {
                opacity: "1",
            } }) }, { children: [showSayLogo && (_jsx(Box, __assign({ onClick: onLogoClick, sx: {
                    ":hover": { cursor: onLogoClick ? "pointer" : undefined },
                    width: "100%",
                    pl: 9.5,
                    py: 5,
                    borderBottom: "1px solid ".concat(COLORS.P_OUTLINE),
                    overflowX: "hidden",
                    transition: "width ease-in-out 300ms",
                } }, { children: open ? (_jsx(SayLogo, { style: { width: "62px", height: "16px" } })) : (_jsx(SaySLogo, { style: { width: "20px", height: "16px" } })) }))), topList, !!listElement && _jsx(_Fragment, { children: listElement }), bottomList, profileProps && (_jsxs(_Fragment, { children: [_jsx(Box, __assign({ sx: {
                            py: 1,
                            px: 3,
                            borderTop: "1px solid ".concat(COLORS.P_OUTLINE),
                        } }, { children: _jsxs(Stack, __assign({ onClick: handleClick, direction: "row", sx: {
                                cursor: "pointer",
                                width: open ? 176 : 72,
                                transition: "width ease-in-out 300ms",
                                whiteSpace: "nowrap",
                                overflowX: "hidden",
                                alignItems: "center",
                                borderRadius: 200,
                                py: 4,
                                pl: 6,
                                "&:hover": {
                                    bgcolor: COLORS.SECONDARY_HOVER,
                                },
                            } }, { children: [profileProps.isBrokerPortal ? (_jsx(ManageAccountsOutlinedIcon, {})) : (_jsx(Logo, { diameter: 24, logoUrl: profileProps.companyLogo, hideBorder: true })), open && (_jsx(Text, __assign({ variant: "body2", ml: 3, textOverflow: "ellipsis", overflow: "hidden" }, { children: profileProps.name })))] })) })), _jsx(ProfileMenu, { handleClose: handleClose, open: !!anchorEl, anchorEl: anchorEl, transformOrigin: {
                            vertical: "bottom",
                            horizontal: "left",
                        }, anchorOrigin: {
                            vertical: "bottom",
                            horizontal: "right",
                        }, PaperProps: { sx: { my: 0, ml: 3, mt: -3 } }, profile: profileProps })] })), toggleExpand && (_jsx(Box, __assign({ className: "MuiDrawer-chevron", sx: {
                    position: "absolute",
                    right: "-16px",
                    top: "calc(50% - 16px)",
                    opacity: "0",
                    transition: "0.2s opacity linear",
                } }, { children: _jsx(Box, __assign({ onClick: toggleExpand, sx: {
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        backgroundColor: "#F0F0F0",
                        border: "1px solid ".concat(COLORS.P_OUTLINE),
                        borderRadius: "100px",
                        width: "32px",
                        height: "32px",
                        cursor: "pointer",
                    } }, { children: _jsx(ChevronRightIcon, { fontSize: "small", sx: {
                            transform: open ? "rotate(180deg)" : "rotate(0deg)",
                            transition: "transform ease-in-out 50ms",
                        } }) })) })))] })));
};
export default MiniDrawer;
